import React, { Component } from 'react';
import { BrowserRouter, Route, Link } from 'react-router-dom';
import {Grid, Divider, Typography} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';


import SideDrawer from './components/sideDrawer/sideDrawer';
import Login from "./components/loginPaper/login";
import creds from './config/firebaseConfig';
import CreateAccount from './pages/createAccount';
import CreateHWK from './pages/createHWK';
import SitHwk from './pages/View/takeHWK';
import Levels from './pages/View/levels';
import Years from './pages/View/years';
import Abilities from './pages/View/abilities';
import ViewPerformance from './pages/View/performance';
import SetHwk from './pages/Create/subject';
import Groups from './pages/Create/groups';
import ViewHwk from './pages/View/viewHwk';
import editTasks from './admin/editTask';
import manageLevels from './admin/manageLevels';
import manageSubjects from './admin/manageSubjects';
import manageYears from './admin/manageYears';
import manageAbilities from './admin/manageAbilities';
import manageSections from './admin/manageSections';
import CreateContent from './pages/Create/content';
import DeleteAccount from './admin/deleteAccount';
import studentDash from './Dashboards/studentDash';
import teacherDash from './Dashboards/teacherDash';
import parentDash from './Dashboards/parentDash';
import adminDash from './Dashboards/adminDash';
import MySubjects from './pages/View/mysubjects';
import EditHwk from './admin/edit';
import EditAccount from './admin/editAccount';
import GroupEdit from './admin/groupEdit';
import AdminViewHwk from './admin/adminViewWork';
import AdminViewWork from './admin/adminViewWork';
import viewStudents from './admin/viewStudents';
import performance2 from './pages/View/performance2';
import performance2_G from './pages/View/performance2_group';



class App extends Component {
  constructor (props)  {
    super (props)
      this.state = { 
        user: {},
        loading: true
      }
    }

    componentDidMount() {
      this.authListener()
      this.currentUser()
    };

    authListener() { 
      creds.fb.auth().onAuthStateChanged((user) => { 
        if (user)  {
          this.setState({ user })
        }
        else  {
          this.setState({ user: null })
        }
      })
    }

    currentUser = () => {
      var user = creds.fb.auth().currentUser

      {(user) ? (
        console.log('Logged in')  
      )
        :
        (
          this.setState({
            user: null,
          })
        ) 
      }
    }
  
  render() {
    return (
      <div className="App">    
        {this.state.user && window.location.pathname != '/'   && window.location.pathname != '/login' ? 
        
        
        ( 

          <SideDrawer>
            <BrowserRouter>
              <React.Fragment>
                <Route exact path='/:id/Student/Dashboard' component={studentDash}/>  {/*For now doesn't call a specific dash but pass the id as props to fix */}
                <Route exact path='/:id/Parent/Dashboard' component={parentDash}/>
                <Route exact path='/:id/Admin/Dashboard' component={adminDash}/>
                <Route exact path='/:id/Teacher/Dashboard' component={teacherDash}/>
                <Route exact path='/:id/tests/:ref' component={SitHwk}/>  {/*For now automatically calls a specific test but pass the ref as props to fix */}
                <Route exact path='/:id/view/tests/:ref' component={AdminViewWork}/>  {/*For now automatically calls a specific test but pass the ref as props to fix */}
                <Route exact path='/:id/mysubjects' component={MySubjects}/>  {/*For now automatically calls a specific test but pass the ref as props to fix */}
                <Route exact path='/:id/tests/:ref/create' component={CreateHWK}/>  {/*For now automatically calls a specific test but pass the ref as props to fix */}
                <Route exact path='/:id/accounts/create' component={CreateAccount}/>    {/*For now automatically calls a specific test but pass the ref as props to fix */}
                <Route exact path='/:id/accounts/edit' component={EditAccount}/>    {/*For now automatically calls a specific test but pass the ref as props to fix */}
                <Route exact path='/:id/accounts/delete' component={DeleteAccount}/>
                <Route exact path='/:id/levels/' component={Levels}/>  {/*For now automatically calls a specific test but pass the ref as props to fix */}
                <Route exact path='/:id/levels/:ref' component={Levels}/>  {/*For now automatically calls a specific test but pass the ref as props to fix */}
                <Route exact path='/:id/levels/:ref/:subject' component={Years}/>  {/*For now automatically calls a specific test but pass the ref as props to fix */}
                <Route exact path='/:id/levels/:ref/:subject/:year' component={Abilities}/>
                <Route exact path='/:id/levels/:ref/:subject/:year/:ability' component={SetHwk}/>
                <Route exact path='/:id/groups/create' component={Groups}/>
                <Route exact path='/:id/groups/edit' component={GroupEdit}/>
                <Route exact path='/:id/groups/delete' component={GroupEdit}/>
                <Route exact path='/:id/viewhwk' component={ViewHwk}/>
                <Route exact path='/:id/:acctype/edittasks' component={editTasks}/>
                <Route exact path='/:id/tasks/view/performance' component={ViewPerformance}/>
                <Route exact path='/:id/tasks/view/performance2' component={performance2}/>
                <Route exact path='/:id/tasks/view/performance2g' component={performance2_G}/>
                <Route exact path='/:id/tasks/view/student' component={viewStudents}/>
                <Route exact path='/:id/:acctype/edittasks/:title' component={EditHwk}/>
                <Route exact path='/:id/:acctype/managelevels' component={manageLevels}/>
                <Route exact path='/:id/:acctype/managelevels/:level' component={manageSubjects}/>
                <Route exact path='/:id/:acctype/managelevels/:level/:subject' component={manageYears}/>
                <Route exact path='/:id/:acctype/managelevels/:level/:subject/:year' component={manageAbilities}/>
                <Route exact path='/:id/:acctype/managelevels/:level/:subject/:year/:ability' component={manageSections}/>
                <Route exact path='/:id/content/create' component={CreateContent}/>
              </React.Fragment>
            </BrowserRouter>
          </SideDrawer>
           ) 
          : (
              window.location.pathname == 'login/' || window.location.pathname == '/' ? 
                <Login/>  
              :
              <Grid container
                spacing={24}
                direction='row'
                justify='space-evenly'
                alignContent='center'
              >  
                <Grid item xs={1} style={{paddingTop: '10%'}}>
                  <CircularProgress/>
                </Grid>
              </Grid>
             
          )} 
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js